import Raven from 'raven-js';
export default (store => next => action => {
  next(action);
  // @ts-expect-error fix type
  Raven.setUser(store.getState());
});